// src/hooks/useNotificationTrigger.js
import { useEffect } from 'react';
import notificationIntegration from '../services/notificationIntegrationService';

export const useNotificationTrigger = () => {
  
  // Déclencher une notification timeline
  const triggerTimelineNotification = async (userId, stepTitle, stepDescription, dossierId, dossierRef) => {
    try {
      await notificationIntegration.notifyTimelineStepUpdate(
        userId, 
        stepTitle, 
        stepDescription, 
        dossierId, 
        dossierRef
      );
    } catch (error) {
      console.error('Erreur déclenchement notification timeline:', error);
    }
  };
  
  // Déclencher une notification de message
  const triggerMessageNotification = async (recipientId, senderName, messagePreview, dossierId, dossierRef) => {
    try {
      await notificationIntegration.notifyNewMessage(
        recipientId, 
        senderName, 
        messagePreview, 
        dossierId, 
        dossierRef
      );
    } catch (error) {
      console.error('Erreur déclenchement notification message:', error);
    }
  };
  
  // Déclencher une notification d'échéance
  const triggerDeadlineNotification = async (userId, dossierRef, daysRemaining, dossierId) => {
    try {
      await notificationIntegration.notifyDeadlineApproaching(
        userId, 
        dossierRef, 
        daysRemaining, 
        dossierId
      );
    } catch (error) {
      console.error('Erreur déclenchement notification échéance:', error);
    }
  };
  
  return {
    triggerTimelineNotification,
    triggerMessageNotification,
    triggerDeadlineNotification
  };
};

// ========================================
// 3. MODIFICATION DU DUALTIMELINE
// ========================================

// À ajouter dans DualTimeline.js après la ligne "await updateDoc(docRef, updates);"

/*
// AJOUT DANS DualTimeline.js après la mise à jour Firestore
import { useNotificationTrigger } from '../../../hooks/useNotificationTrigger';

const DualTimeline = () => {
  const { triggerTimelineNotification } = useNotificationTrigger();
  
  // ... code existant ...
  
  const toggleStatus = async (etapeId) => {
    // ... code existant jusqu'à updateDoc ...
    
    await updateDoc(docRef, updates);
    
    // ✅ NOUVEAU: Déclencher notification automatique
    try {
      // Récupérer les infos du dossier et de l'étape
      const etapeInfo = etapes.find(e => e.id === etapeId);
      const dossierRef = dossierData.clientName || dossierData.titre || 'Dossier';
      
      if (etapeInfo && dossierData.clientId) {
        await triggerTimelineNotification(
          dossierData.clientId,
          etapeInfo.nom,
          `L'étape "${etapeInfo.nom}" a été ${newStatus === 'terminee' ? 'terminée' : 'mise à jour'}`,
          dossierId,
          dossierRef
        );
      }
    } catch (error) {
      console.error('Erreur notification timeline:', error);
    }
    
    // ... reste du code existant ...
  };
};
*/

// ========================================
// 4. ENDPOINTS API MANQUANTS
// ========================================

// public/api/send-push-notification.js (si vous utilisez Next.js)
// OU créer un fichier PHP send-push-notification.php

/*
// Option 1: Endpoint Node.js/Next.js
export default async function handler(req, res) {
  if (req.method !== 'POST') {
    return res.status(405).json({ error: 'Method not allowed' });
  }
  
  const { token, title, body, data } = req.body;
  
  try {
    // Utiliser Firebase Admin SDK pour envoyer la notification
    const admin = require('firebase-admin');
    
    if (!admin.apps.length) {
      admin.initializeApp({
        credential: admin.credential.cert({
          projectId: process.env.FIREBASE_PROJECT_ID,
          clientEmail: process.env.FIREBASE_CLIENT_EMAIL,
          privateKey: process.env.FIREBASE_PRIVATE_KEY.replace(/\\n/g, '\n'),
        }),
      });
    }
    
    const message = {
      notification: { title, body },
      data: data || {},
      token: token,
    };
    
    const response = await admin.messaging().send(message);
    
    res.status(200).json({ success: true, messageId: response });
  } catch (error) {
    console.error('Error sending push notification:', error);
    res.status(500).json({ error: 'Failed to send push notification' });
  }
}
*/

// ========================================
// 5. ALTERNATIVE SMS SIMPLE
// ========================================

// public/api/send-sms.js
/*
export default async function handler(req, res) {
  if (req.method !== 'POST') {
    return res.status(405).json({ error: 'Method not allowed' });
  }
  
  const { to, message } = req.body;
  
  try {
    // Option 1: Utiliser un service SMS comme Twilio
    const twilio = require('twilio');
    const client = twilio(process.env.TWILIO_ACCOUNT_SID, process.env.TWILIO_AUTH_TOKEN);
    
    const result = await client.messages.create({
      body: message,
      from: process.env.TWILIO_PHONE_NUMBER,
      to: to
    });
    
    res.status(200).json({ success: true, messageId: result.sid });
  } catch (error) {
    console.error('Error sending SMS:', error);
    res.status(500).json({ error: 'Failed to send SMS' });
  }
}
*/

// ========================================
// 6. CONFIGURATION .ENV NÉCESSAIRE
// ========================================

/*
# Dans votre fichier .env
REACT_APP_EMAILJS_SERVICE_ID=your_service_id
REACT_APP_EMAILJS_TEMPLATE_ID=your_template_id  
REACT_APP_EMAILJS_PUBLIC_KEY=your_public_key
REACT_APP_FIREBASE_VAPID_KEY=your_vapid_key
REACT_APP_FRONTEND_URL=http://localhost:3000

# Pour SMS (optionnel)
TWILIO_ACCOUNT_SID=your_twilio_account_sid
TWILIO_AUTH_TOKEN=your_twilio_auth_token
TWILIO_PHONE_NUMBER=your_twilio_phone_number

# Pour Push (backend)
FIREBASE_PROJECT_ID=your_project_id
FIREBASE_CLIENT_EMAIL=your_client_email
FIREBASE_PRIVATE_KEY=your_private_key
*/

// ========================================
// 7. UTILISATION SIMPLE
// ========================================

/*
// Exemple d'utilisation dans un composant React:

import notificationIntegration from '../services/notificationIntegrationService';

const MyComponent = () => {
  const handleSendNotification = async () => {
    try {
      const result = await notificationIntegration.createAndSendNotification({
        recipientId: 'user123',
        title: 'Test notification',
        message: 'Ceci est un test',
        type: 'info',
        urgency: 'normal',
        dossierId: 'dossier123',
        dossierRef: 'DOSSIER-001'
      });
      
      console.log('Notification envoyée:', result);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };
  
  return (
    <button onClick={handleSendNotification}>
      Envoyer notification test
    </button>
  );
};
*/